import React from 'react';
import classNames from 'classnames';

import css from './IconTrustpilot.module.css';

/**
 * Review star icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconTrustpilot = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || className);

  return (
    <svg
      className={classes}
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10.9795L10.0417 10.2086L11.3125 14.1253L7 10.9795ZM14 5.91697H8.64583L7 0.875305L5.35417 5.91697H0L4.33334 9.04197L2.6875 14.0836L7.02083 10.9586L9.6875 9.04197L14 5.91697Z"
        fill="#219653"
      />
    </svg>
  );
};

export default IconTrustpilot;
